import React from "react";
import { Navigation } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StepsFromTheSacred() {
  return <section data-section-id="224794" id="kde-nás-najdete" className="bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[600px]">
        
        <div className="lg:col-span-12 bg-secondary flex flex-col items-center justify-center p-8 sm:p-12 lg:p-16 xl:p-24 relative z-20 text-center">
          {}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--primary)_1px,_transparent_1px)] bg-[size:24px_24px]" />
          
          <div className="relative z-10 max-w-2xl flex flex-col items-center">
            <Badge variant="outline" className="mb-8 border-primary/40 text-primary bg-primary/5 px-4 py-1.5 text-sm uppercase tracking-widest font-semibold">
              Privátní lokalita
            </Badge>
            
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-default font-semibold text-primary mb-6 leading-tight">
              Kde nás najdete
            </h2>
            
            <div className="space-y-6 text-foreground/80 text-lg sm:text-xl font-serif leading-relaxed mb-10">
              <p>Buzulucká, Teplice - Řetenice<br /></p>
              <p></p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base h-14 px-8 rounded-full shadow-lg shadow-primary/10">
                
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary/40 text-primary hover:bg-primary hover:text-primary-foreground text-base h-14 px-8 bg-transparent rounded-full transition-all duration-300">
                
              </Button>
            </div>
          </div>
        </div>

      </div>
    </section>;
}